import { runImpactCalculateTourCo2ForProject } from '@/domain/impact-calculate-tour/actions/run-impact-calculate-tour-co2-for-project.action';
import { selectCurrentProjectTour } from '@/domain/project-tour/project-tour.selectors';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

import { TourEvent } from '../entities/project-tour-ontour-event.entity';
import { getTourEvents } from './get-tour-events.action';
import { updateTravelDistanceForLinkedTravelsIfNeeded } from './update-travel-distance-for-linked-travels';

type Params = {
  tourEvent: TourEvent;
  updatePosition: boolean;
};

type Result = void;

export const editTourEvent = createAppAsyncThunk(
  'projectTourOntour/editTourEvent',
  async (
    params: Params,
    {
      extra: { projectTourOntourGateway, snackbarGateway },
      dispatch,
      getState,
    },
  ): Promise<Result> => {
    try {
      await projectTourOntourGateway.editEvent(params.tourEvent);
      dispatch(getTourEvents({ sequenceId: params.tourEvent.sequenceId }));
      const projectId = selectCurrentProjectTour(getState())?.id || -1;
      await dispatch(runImpactCalculateTourCo2ForProject({ projectId }));
      showSnackbarSuccess(snackbarGateway);
      if (params.updatePosition) {
        dispatch(
          updateTravelDistanceForLinkedTravelsIfNeeded({
            tourEvent: params.tourEvent,
          }),
        );
      }
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarSuccess(snackbarGateway: SnackbarGateway) {
  snackbarGateway.success(translate('EditTourEvent.Message.success'));
}

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('EditTourEvent.Message.error'));
}
